<template>
  <v-container grid-list-xl fluid text-xs-center class="pt-0">
        <v-layout>
            <v-flex>
                <v-img :src="user.cover_image" height="260" class="w-100 card-r grey lighten-3" ></v-img>
            </v-flex>
        </v-layout>
        
        <v-layout row class="text-xs-center">
            <v-flex xs12 class="profileImgd">
                <v-img :src="user.image" class="white" style="border: 3px solid #002f6f !important;"></v-img>
                <span class="headline font-weight-black text-capitalize">{{user.name}}</span> <br>
                <!--<span class="subheading font-weight-light text-capitalize">{{user.address+" "+user.city+" "+user.zip}}</span>-->
            </v-flex>
        </v-layout>
        <v-layout class="personalcontent" row>
              <!--<v-flex xs12 md12 lg12 class="about">-->
                  <!--<p class="title font-weight-bold">My Profile</p>-->
              <!--</v-flex>-->
          </v-layout>
      <v-container fluid grid-list-xl class="pa-0">
        <v-layout row wrap class="">
          <v-flex d-flex lg12 sm12 xs12 class="pt-0 pb-0">
            <div class="text-xs-center">
              <!--<span class="headline font-weight-black text-capitalize">{{user.name}}</span> <br>-->
              <span class="text-capitalize f-14 font-weight-bold"> HeyWay!! Learn Fast !! Drive Fast !!
                </span>
              <!-- <p class="title font-weight-bold">About</p> -->
              <p class="text-xs-justify">
               HeyWay is drivers ed and defensive driving online and on your time. Our fun and engaging courses can be taken via iOS and Android apps or on a computer. ... Save hundreds of dollars on driving school with our all-in-one online courses
              </p>
            </div>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pa-0">
            <v-card class="PersonalCards pa-0  no-shadow card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs4 class="label pa-0"><p> Full Name </p> </v-flex>
                <v-flex xs8 class="w-100 text-xs-right pa-0">{{user.name}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pa-0">
            <v-card class="PersonalCards pa-0  no-shadow card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs2 class="label pa-0"><p>Email</p> </v-flex>
                <v-flex xs10 class="w-100 text-xs-right pa-0">{{user.email}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pa-0">
            <v-card class="PersonalCards pa-0  no-shadow card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs6 class="label pa-0"><p>Phone Number</p> </v-flex>
                <v-flex xs6 class="w-100 text-xs-right pa-0">{{user.phone==null?"-":user.phone}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pa-0">
            <v-card class="PersonalCards pa-0  no-shadow card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs4 class="label pa-0"><p>Date of Birth</p> </v-flex>
                <v-flex xs8 class="w-100 text-xs-right pa-0">{{user.dob==null?"-":user.dob}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pa-0">
            <v-card class="PersonalCards pa-0  no-shadow card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs2 class="label pa-0"><p>Address</p> </v-flex>
                <v-flex xs10 class="w-100 text-xs-right pa-0">{{UserAddress==null?"-":UserAddress}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pa-0">
            <v-card class="PersonalCards pa-0  no-shadow card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs6 class="label pa-0"><p>City</p> </v-flex>
                <v-flex xs6 class="w-100 text-xs-right pa-0">{{user.city==null?"-":user.city}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pa-0">
            <v-card class="PersonalCards pa-0  no-shadow card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs4 class="label pa-0"><p>Zip Code</p> </v-flex>
                <v-flex xs8 class="w-100 text-xs-right pa-0">{{user.zipCode==null?"-":user.zipCode}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pa-0">
            <v-card class="PersonalCards pa-0  no-shadow card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs4 class="label pa-0"><p>Gender</p> </v-flex>
                <v-flex xs8 class="w-100 text-xs-right pa-0">{{user.gender}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>


      <!--<v-layout row class="text-xs-center personaldetails">-->
            <!--<v-flex xs6>-->
                <!--<v-card class="PersonalCards">-->
                        <!--<v-layout row>-->
                            <!--<v-flex xs4 class="label"><p>Full Name</p> </v-flex>-->
                            <!--<v-flex xs6>{{user.name}}</v-flex>-->
                        <!--</v-layout>-->
                    <!--</v-card>-->


                    <!--<v-card class="PersonalCards">-->
                        <!--<v-layout row>-->
                            <!--<v-flex xs4 class="label"> <p>Email</p></v-flex>-->
                            <!--<v-flex xs6>{{user.email}}</v-flex>-->
                        <!--</v-layout>-->
                    <!--</v-card>-->


                    <!--<v-card class="PersonalCards">-->
                        <!--<v-layout row>-->
                            <!--<v-flex xs4 class="label"><p>Phone Number</p></v-flex>-->
                            <!--<v-flex xs6>{{user.phone}}</v-flex>-->
                        <!--</v-layout>-->
                    <!--</v-card>-->


                    <!--<v-card class="PersonalCards">-->
                        <!--<v-layout row>-->
                            <!--<v-flex xs4 class="label"><p>Date of Birth</p></v-flex>-->
                            <!--<v-flex xs6>{{user.dob}}</v-flex>-->
                        <!--</v-layout>-->
                    <!--</v-card>-->


                    <!--<v-card class="PersonalCards">-->
                        <!--<v-layout row>-->
                            <!--<v-flex xs4 class="label"><p>Address</p></v-flex>-->
                            <!--<v-flex xs6>{{UserAddress}}</v-flex>-->
                        <!--</v-layout>-->
                    <!--</v-card>-->
            <!--</v-flex>-->
                <!--<v-flex xs6>-->

                    <!--<v-card class="PersonalCards">-->
                        <!--<v-layout row>-->
                            <!--<v-flex xs4 class="label"><p>City</p></v-flex>-->
                            <!--<v-flex xs6>{{user.city}}</v-flex>-->
                        <!--</v-layout>-->
                    <!--</v-card>-->


                    <!--<v-card class="PersonalCards">-->
                        <!--<v-layout row>-->
                            <!--<v-flex xs4 class="label"><p>Zip Code</p></v-flex>-->
                            <!--<v-flex xs6>{{user.zipCode}}</v-flex>-->
                        <!--</v-layout>-->
                    <!--</v-card>-->


                    <!--<v-card class="PersonalCards">-->
                        <!--<v-layout row>-->
                            <!--<v-flex xs4 class="label"><p>Gender</p></v-flex>-->
                            <!--<v-flex xs6>{{user.gender}}</v-flex>-->
                        <!--</v-layout>-->
                    <!--</v-card>-->

                <!--&lt;!&ndash;-->
                    <!--<v class="PersonalCards"-card>-->
                        <!--<v-layout row>-->
                            <!--<v-flex xs6>Full Name</v-flex>-->
                            <!--<v-flex xs6>{{user.name}}</v-flex>-->
                        <!--</v-layout>-->
                    <!--</v-card>-->
                <!--</div> &ndash;&gt;-->
            <!--</v-flex>-->
        <!--</v-layout>-->
    </v-container>
</template>

<script>
/* eslint-disable */
  import { mapState, dispatch } from 'vuex'

export default {
    name: "personal",
    data: () => ({
        ProfileImg : "https://prodwpids-idrivesafely.netdna-ssl.com/wp-content/themes/enterprise-pro/images/insurance-portal/Insurance_Woman_Driver.jpg",
        coverPhoto : "https://m.sephora.ae/wysiwyg/brands/500x500_BOSS_BOTTLED_Gearshift.jpg",
        UserAddress:this.nullCheck(Store.state.user.street)+' '+
                    this.nullCheck(Store.state.user.streetNumber)+' '+
                    this.nullCheck(Store.state.user.floor)+' '+
                    this.nullCheck(Store.state.user.door)+' '+
                    this.nullCheck(Store.state.user.zipCode)+' '+
                    this.nullCheck(Store.state.user.city),
    }),
    computed:{
        ...mapState({

        user: 'user',
        loading: 'loading',
        mode: 'mode'
      }),
  },
  created:()=>{
      this.$router.push({ path:`/Profile` })

  },
  methods:{
      nullCheck(value){
        if(value){
          return value+' ';
        }else{
          return ""
        }
      },
  }

};
</script>



// WEBPACK FOOTER //
// src/pages/pages/profile/Personal.vue